"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgAmenityShuttle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992 240h-64v-32c0-89.6-70.4-160-160-160H256c-89.6 0-160 70.4-160 160v32H32c-19.2 0-32 12.8-32 32v160c0 19.2 12.8 32 32 32h64v384c0 19.2 12.8 32 32 32h48v64c0 19.2 12.8 32 32 32h128c19.2 0 32-12.8 32-32v-64h288v64c0 19.2 12.8 32 32 32h128c19.2 0 32-12.8 32-32v-64h48c19.2 0 32-12.8 32-32V464h64c19.2 0 32-12.8 32-32V272c0-19.2-12.8-32-32-32zM96 400H64v-96h32v96zm64-96h320v224H160V304zm704 512H160V592h704v224zm0-288H544V304h320v224zm0-288H160v-32c0-54.4 41.6-96 96-96h512c54.4 0 96 41.6 96 96v32zm96 160h-32v-96h32v96zM224 704c0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48zm480 0c0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48-48-21.5-48-48z"
  }));
}

var ForwardRef = React.forwardRef(SvgAmenityShuttle);
var _default = ForwardRef;
exports.default = _default;